import { Controller, useFormContext } from 'react-hook-form';

import RadioButtonV2 from './radio-button-v2';
import { RadioButtonV2Props } from './radio-button-v2.types';

export function RadioButtonRhf(props: Readonly<RadioButtonV2Props>) {
  const { name, rules, onChange } = props;
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field, fieldState }) => {
        const { value, ...rest } = field;

        const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
          field.onChange(event); // update the form state
          onChange?.(event); // call user-defined handler
        };
        const isChecked = value != null && value.toString() === props.value.toString();
        const radioButtonProps: RadioButtonV2Props = {
          ...props,
          ...rest,
          checked: isChecked,
          onChange: handleChange,
          error: !!fieldState.error?.message,
        };
        return <RadioButtonV2 {...radioButtonProps} />;
      }}
    />
  );
}
